import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { withStyles, Select, Menu, Button, MenuItem, FormControl, InputLabel, ButtonGroup, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';
import * as Yup from "yup";
import moment from 'moment';

import { hasPermission, isSuperUser } from '../../sc-utilities';
import { saveTableViewStyle } from './utils';

import * as actions from './store/productOverviewActions';
import TableViewForm from './TableViewForm';
import { CancelToken } from 'axios';
import { useCallback } from 'react';

const styles = theme => (saveTableViewStyle(theme));
const TableView = (props) => {

    const { classes, setEdited, activeCustomerID, onCreateTableView, hideViewSelector, edited, loadTableView, updateView, currentView, fetchTableView, onEditTableView, permissions, tableRef, translations, groupsLookup } = props;

    const tableViewCancel = CancelToken.source();
    const [saveTableViewState, setSaveTableViewState] = useState({ open: false, anchorEl: null });
    const [state, setState] = useState({
        tableViews: tableRef?.current?.customTableViewSetup?.tableViews ?? [],
        selectedTableView: tableRef?.current?.customTableViewSetup?.selectedTableView ?? null,
        Name: tableRef?.current?.customTableViewSetup?.Name ?? null,
        QueryType: tableRef?.current?.customTableViewSetup?.QueryType ?? null,
    });

    let initialValues = {
        Name: "",
        type: 'customer'
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
        },
        ButtonSubmit:
            hasPermission(permissions, "table_view_create") ? {
                Title: translations["save"] || "SAVE",
                Color: 'primary'
            } : null,

        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: () => handleOpenClose()
        }
    };

    const loadTableViewData = useCallback(async (id, shouldUpdateView = true) => {
        id = id?.toString()?.split('_')[0] || null;
        const result = await fetchTableView({ ActiveCustomerID: activeCustomerID }, { tableViewCancel: tableViewCancel });

        if (result.length > 0 && tableRef?.current?.state) {
            tableRef.current.state.TableViewID = id ? id : result[0]?.TableViewID;
            const tableViewResult = await loadTableView({ ActiveCustomerID: activeCustomerID, TableViewID: id ? id : result[0]?.TableViewID }, { tableViewCancel: tableViewCancel });
            if (!tableViewResult && !tableViewResult?.Parameters) {
                return
            }
            let tableState = typeof (tableViewResult?.Parameters) === 'string' ? JSON.parse(tableViewResult.Parameters) : tableViewResult?.Parameters;
            if (tableState) {
                let cols = tableState?.columns ?? [];

                let idx = cols.findIndex(el => el?.field === tableState?.query?.orderBy?.field);

                if (!tableRef.current || !tableRef.current.state) {
                    return;
                }
                tableRef.current.state.columns = tableState?.columns ?? [];
                tableRef.current.state.orderDirection = tableState?.orderDirection === 'asc' || tableState?.orderDirection === 'desc' ? tableState?.orderDirection : 'asc';
                tableRef.current.state.orderBy = (idx && cols[idx]?.tableData?.columnOrder) ?? -1;

                const previousFilters = tableRef.current.state.query.filters;

                tableRef.current.state.query = tableState?.query ?? { totalCount: 0, page: 1, pageSize: 0 };

                if (previousFilters && previousFilters.length>0) {
                    const filtersObject = previousFilters?.reduce((acc, filter) => {
                        if (filter.value instanceof Array && filter.value.length===0) {
                            return acc;
                        }
                        acc[filter.column.field] = filter.value;
                        return acc;
                    }, {});

                    if (tableRef?.current?.state?.query?.filters && tableRef?.current?.state?.query?.filters instanceof Array) {
                        const updatedFilters = tableRef.current.state.query.filters.map((tableFilter) => {
                            const filterName = tableFilter.column.field;
                            if (Object.keys(filtersObject).includes(filterName)) {
                                return {
                                    ...tableFilter,
                                    value: filtersObject[filterName]
                                }
                            } else {
                                return tableFilter;
                            }
                        })
                        tableRef.current.state.query.filters = updatedFilters;
                    }
                }

                const tableFilters = tableRef?.current?.state?.query?.filters;
                if (!hasPermission(permissions, 'group_list')) {
                    const filtered = tableFilters?.filter((f) => f.column.field!=="GroupID");
                    if (tableRef?.current?.state?.query && filtered) {
                        tableRef.current.state.query.filters = filtered;
                    }
                }

                if (!tableRef.current || !tableRef.current.state) {
                    return;
                }

                if (tableRef?.current && tableRef.current.dataManager) {
                    tableRef.current.dataManager.columns = tableState?.columns ?? [];
                    tableRef.current.dataManager.orderDirection = tableState?.orderDirection === 'asc' || tableState?.orderDirection === 'desc' ? tableState?.orderDirection : 'asc';
                    tableRef.current.dataManager.orderBy = (idx && cols[idx]?.tableData?.columnOrder) ?? -1;
                }

                if (tableState?.query) {
                    tableState.query.totalCount = 0;
                    tableState.query.page = 0;
                    tableState.query.orderBy = idx && cols[idx];
                }

            };

            if (!tableRef.current || !tableRef.current.state) {
                return;
            }

            if (tableRef?.current && tableRef.current.state && tableRef.current.dataManager) {
                tableRef.current.state.QueryType = tableViewResult?.QueryType;
                tableRef.current.state.TableViewName = tableViewResult?.Name;
                tableRef.current.dataManager.QueryType = tableViewResult?.QueryType;
                tableRef.current.dataManager.TableViewName = tableViewResult?.Name;

                tableRef.current.customTableViewSetup = {
                    tableViews: result,
                    selectedTableView: id ? id : result[0]?.TableViewID,
                    Name: tableViewResult?.Name,
                    QueryType: tableViewResult?.QueryType,
                    CustomerID: tableViewResult?.CustomerID
                };
            }

            setState({ tableViews: result, selectedTableView: id ? id : result[0]?.TableViewID, Name: tableViewResult?.Name, QueryType: tableViewResult?.QueryType });
            updateView(`${id ? id : result[0]?.TableViewID}_${moment().valueOf()}`);
            if (shouldUpdateView) {
                tableRef.current && tableRef.current.onQueryChange();
            }
        }
        // eslint-disable-next-line
    }, [activeCustomerID, fetchTableView, loadTableView, tableRef, groupsLookup]);

    const handleChange = event => {
        if (tableRef?.current?.state?.query) {
            tableRef.current.state.query.filters = {};
        }
        loadTableViewData(event.target.value, false);
        loadTableViewData(event.target.value);
    };

    const handleClick = (event) => {
        setSaveTableViewState({ ...saveTableViewState, anchorEl: event.currentTarget });
    };

    const handleClose = () => {
        setSaveTableViewState({ ...saveTableViewState, anchorEl: null });
    };

    const handleDiscard = () => {
        if (currentView) {
            setEdited(true);
            loadTableViewData(currentView);
            handleClose();
        }
    };

    const handleOpenClose = () => {
        setSaveTableViewState({ ...saveTableViewState, open: !saveTableViewState.open })
    };

    const handleSaveAs = async (data) => {
        const columns = tableRef?.current?.state?.columns ?? [];
        const orderDirection = tableRef?.current?.dataManager?.orderDirection ?? 'asc';
        const query = tableRef?.current?.state?.query ?? {};
        delete query.totalCount;
        let orderBy = 0;
        if (query?.orders && query?.orders[0]) {
            for (const column of columns) {
                if (column.field === query?.orders[0]?.field) {
                    orderBy = column?.tableData?.columnOrder;
                    break;
                }
            }
        }

        let result = await onCreateTableView({
            ActiveCustomerID: activeCustomerID,
            Name: data.Name,
            Parameters: JSON.stringify({ columns: columns, orderDirection: orderDirection, orderBy: orderBy, query: query }),
            QueryType: state?.QueryType ?? 'ProductsAll',
            CustomerID: data?.type.includes('system') ? null : activeCustomerID
        },
            { tableViewCancel: tableViewCancel });

        if (result) {
            let id = result?.TableViewID;
            loadTableViewData(id);
        }
        setEdited(true);

    };

    const handleSave = async () => {
        const columns = tableRef?.current?.state?.columns ?? [];
        const orderDirection = tableRef?.current?.dataManager?.orderDirection ?? 'asc';
        const query = tableRef?.current?.state?.query ?? {};
        let orderBy = 0;
        let newColumns = columns.map((el) => {
            return {
                columnOrder: el?.columnOrder ?? null,
                defaultFilter: el?.defaultFilter ?? null,
                defaultSort: el?.defaultSort ?? null,
                field: el?.field ?? null,
                hidden: el?.hidden ?? false,
                export: el?.export ?? null,
                filtering: el?.filtering ?? null,
                sorting: el?.sorting ?? null,
                render: el?.render ?? null,
                title: el?.title ?? null,
                tableData: { columnOrder: el?.tableData?.columnOrder ?? null, filterValue: el?.tableData?.filterValue ?? null, id: el?.tableData?.id }
            }
        });
        let cleanedColumns = [];
        for (let column of newColumns) {
            cleanedColumns.push(Object.entries(column).reduce((a, [k, v]) => (v === null ? a : (a[k] = v, a)), {}));
        };
        delete query.totalCount;
        if (query?.orders && query?.orders[0]) {
            for (const column of cleanedColumns) {
                if (column.field === query?.orders[0]?.field) {
                    orderBy = column?.tableData?.columnOrder;
                    break;
                }
            }

        };

        await onEditTableView({
            ActiveCustomerID: activeCustomerID,
            TableViewID: state?.selectedTableView,
            Name: state?.Name,
            Parameters: JSON.stringify({ columns: cleanedColumns, orderDirection: orderDirection, orderBy: orderBy, query: query }),
            QueryType: state?.QueryType,
            CustomerID: isSuperUser() ? null : activeCustomerID
        },
            { tableViewCancel: tableViewCancel });

        setEdited(true);
    };

    useEffect(() => {
        if (!state?.selectedTableView && !currentView) {
            loadTableViewData(null);
        }
    // eslint-disable-next-line
    }, [currentView, state, tableRef]);

    const buttonGroupWithMenu =
        <Menu
            {...props.rest}
            id="simple-menu"
            anchorEl={saveTableViewState?.anchorEl}
            keepMounted
            variant='menu'
            open={Boolean(saveTableViewState?.anchorEl)}
            onClose={handleClose}
        >
            {hasPermission(permissions, 'system_table_view_save') || state?.tableView?.CustomerID === activeCustomerID ? <MenuItem disabled={edited} onClick={() => { handleSave(); handleClose(); }}>{translations['save'] || 'Save'} </MenuItem> : null}
            <MenuItem disabled={edited} onClick={() => setSaveTableViewState({ open: true, anchorEl: null })}>{translations['save_as'] || 'Save as'}</MenuItem>
            <MenuItem disabled={edited} onClick={handleDiscard}>{translations['discard'] || 'Discard'}</MenuItem>
        </Menu >

    const dropdown = (
        <div>
            <FormControl className={classes.formControl} margin={"dense"} >
                <InputLabel shrink>{translations["table_view_select"] || "Please select table view"}</InputLabel>
                <Select
                    name="tableViewID"
                    label={translations["table_view"] || 'Table View'}
                    margin={"dense"}
                    value={state?.selectedTableView || tableRef.current?.state?.TableViewID || ''}
                    onChange={handleChange}
                >
                    {(state?.tableViews ? state?.tableViews : []).map(option => (
                        <MenuItem key={option.TableViewID} value={option.TableViewID}>
                            {option.Name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            { buttonGroupWithMenu}

            {
                hasPermission(permissions, 'table_view_save') ? <ButtonGroup
                    {...props.rest}
                    {...props.children}
                    className={classes.buttonDisplay}>
                    <Button size="small" variant="contained" disabled={edited || !hasPermission(permissions, 'system_table_view_save') || (!hasPermission(permissions, 'system_table_view_save') && tableRef.current.customTableViewSetup?.CustomerID !== activeCustomerID)} onClick={handleSave}
                        color="primary">{translations['save'] || 'Save'}</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        aria-controls={saveTableViewState.open ? 'split-button-menu' : undefined}
                        aria-expanded={saveTableViewState.open ? 'true' : undefined}
                        aria-label="select merge strategy"
                        aria-haspopup="menu"
                        onClick={handleClick}
                    >
                        <ArrowDropDown />
                    </Button>
                </ButtonGroup > : null
            }
        </div >);
    if (hideViewSelector) {
        return null;
    } else {

        return (
            < div >
                { state?.tableViews?.length > 0 && dropdown}
                <Dialog open={saveTableViewState.open} classes={{ paper: classes.dialogPaper }} onClose={handleOpenClose} aria-labelledby="form-dialog-title">
                    <DialogTitle className={classes.title} id="form-dialog-title">{translations['save_table_view'] || "Save table view"}</DialogTitle>
                    <DialogContent>
                        <TableViewForm handleOpenClose={handleOpenClose} initialValues={initialValues} permissions={permissions} formSettings={formSettings} translations={translations} handleSubmit={handleSaveAs} />
                    </DialogContent>
                </Dialog>
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        translations: state?.translate?.translations?.activeTranslations || {},
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID || null,
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        fetchTableView: params => dispatch(actions.fetchTableView(params)),
        loadTableView: params => dispatch(actions.loadTableView(params)),
        onCreateTableView: params => dispatch(actions.createTableView(params)),
        onEditTableView: params => dispatch(actions.editTableView(params)),
        onFetchProductType: params => dispatch(actions.listProductTypes(params))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(TableView));
